import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Loader from '~/core/components/Loader';
import { Modal } from '~/core/components/Modal';
import { useToast } from '~/core/contexts/ToastContext';
import { twitterAuthRedirectStorage } from '~/core/storages';
import { api } from '../api';

export const atomTwitterModal = {
  visible: atom<boolean>(false),
};

export const ConnectTwitterModal = () => {
  const [visible, setVisible] = useAtom(atomTwitterModal.visible);
  const { pathname, search } = useLocation();
  const toast = useToast();

  useEffect(() => {
    if (visible) {
      initiateTwitterAuth();
    }
  }, [visible]);

  const initiateTwitterAuth = async () => {
    try {
      const callbackUrl = `${window.location.origin}/twitter-callback`;
      const { url } = await api.initTwitterAuth(callbackUrl);
      window.location.href = url;
      twitterAuthRedirectStorage.set(`${pathname}${search}`);
    } catch (error) {
      console.error('𝕏 auth initiation failed:', error);
      toast.error('Failed to initiate 𝕏 auth');
    } finally {
      setVisible(false);
    }
  };

  return (
    <Modal
      visible={visible}
    >
      <div className='flex items-center justify-center w-full h-40'>
        <Loader size='32px' stroke='#191d29' />
      </div>
    </Modal>
  );
};
